<template>
  <div>
    <b-modal id="modal-add-category" :ref="ref" title="Add Category" hide-footer lazy>
      <form @submit.prevent="submit">
        <loading-wrap :loading="loading">
          <div v-if="loading === false">
            <div class="form-group">
              <label>Category Name</label>
              <input type="text" class="form-control" v-model="form.name" required>
            </div>
            <div class="form-group">
              <label>Category Subject</label>
              <v-select
                v-model="form.subject"
                :clearable="false"
                :options="['english', 'maths']"
                label="name"
              >
                <template slot="selected-option" slot-scope="option">
                  <span style="text-transform: capitalize">{{option.name}}</span>
                </template>
                <template slot="option" slot-scope="option">
                  <div class="d-flex">
                    <span style="text-transform: capitalize">{{option.name}}</span>
                  </div>
                </template>
              </v-select>
            </div>
            <hr>
            <div>
              <button
                type="submit"
                class="btn btn-primary btn-block btn-lg"
                :disabled="formLoading"
              >
                <svg-loader/>
                <span>Add Category</span>
              </button>
            </div>
          </div>
        </loading-wrap>
      </form>
    </b-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      formLoading: false,
      form: {
        name: null,
        subject: null
      },
      ref: String(Math.random()).slice(2, 8)
    };
  },
  methods: {
    submit() {
      this.formLoading = true;
      this.axios.post("/api/categorys", this.form).then(res => {
        this.$_closeModal();
        this.form = {};
        this.$root.$emit("popup", "Category successfully added.");
      });
    }
  }
};
</script>
